/* Cosmeceutical Solutions - premium reveal (bulletproof scroll-sweep). Safe: .cs-reveal added by JS only. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var CARD_SEL = '.collection-product-card, .product-carousel-section .card-wrapper';
  var ticking = false;

  function sweep() {
    ticking = false;
    var vh = window.innerHeight || 800;
    var els = document.querySelectorAll('.cs-reveal:not(.cs-in)');
    for (var i = 0; i < els.length; i++) {
      if (els[i].getBoundingClientRect().top < vh * 0.92) els[i].classList.add('cs-in');
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }

  function setup() {
    var scope = document.getElementById('MainContent') || document.body;
    var cards = scope.querySelectorAll(CARD_SEL);
    cards.forEach(function (c) {
      c.classList.add('cs-reveal');
      c.style.transitionDelay = '0ms';
    });
    var secs = scope.querySelectorAll('.shopify-section');
    secs.forEach(function (sec, i) {
      if (i === 0) return;
      if (sec.querySelector('.cs-ts-instance')) return;
      if (sec.querySelector(CARD_SEL)) return;
      sec.classList.add('cs-reveal');
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('load', function () { sweep(); setTimeout(sweep, 400); });
    sweep();
    setTimeout(sweep, 300);
    setTimeout(sweep, 1200);
  }

  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', setup);
})();

/* Wholesale Order Form: quick range links above the product table.
   The WSH order form supports one URL per collection (/apps/shop/<handle>),
   so these are plain links - they do not depend on the app's internal markup.
   If a handle is ever renamed the link 404s to the full list, nothing breaks. */
(function () {
  if (location.pathname.indexOf('/apps/shop') !== 0) return;

  var RANGES = [
    ['All products', ''],
    ['Thermoceutical retail', 'thermoceutical-retail'],
    ['Thermoceutical professional', 'thermoceutical-professional'],
    ['Celestetic retail', 'celestetic-retail'],
    ['Celestetic professional', 'celestetic-professional'],
    ['SkinB5', 'skinb5']
  ];

  function styles() {
    if (document.getElementById('cs-wof-style')) return;
    var st = document.createElement('style');
    st.id = 'cs-wof-style';
    st.textContent =
      '.cs-wof-ranges{display:flex;flex-wrap:wrap;justify-content:center;gap:10px;margin:20px 0 30px}' +
      '.cs-wof-ranges a{font-family:Mulish,sans-serif;font-size:13px;letter-spacing:.055em;' +
      'padding:11px 18px;border:1px solid #192846;background:#fff;color:#192846;' +
      'text-decoration:none;line-height:1;transition:background .2s ease,color .2s ease}' +
      '.cs-wof-ranges a:hover{background:#192846;color:#FFFAF8}' +
      '.cs-wof-ranges a[aria-current="true"]{background:#192846;color:#FFFAF8}' +
      '@media (max-width:749px){.cs-wof-ranges{gap:8px;margin:16px 0 24px}' +
      '.cs-wof-ranges a{font-size:12px;padding:10px 14px}}';
    document.head.appendChild(st);
  }

  function build() {
    var bar = document.getElementById('wof_top_bar');
    if (!bar || document.querySelector('.cs-wof-ranges')) return !!bar;
    styles();
    var here = (location.pathname.split('/apps/shop')[1] || '').replace(/^\//, '').replace(/\/+$/, '');
    var wrap = document.createElement('div');
    wrap.className = 'cs-wof-ranges';
    RANGES.forEach(function (r) {
      var a = document.createElement('a');
      a.href = '/apps/shop' + (r[1] ? '/' + r[1] : '');
      a.textContent = r[0];
      if (here === r[1]) a.setAttribute('aria-current', 'true');
      wrap.appendChild(a);
    });
    bar.parentNode.insertBefore(wrap, bar.nextSibling);
    return true;
  }

  function start() {
    if (build()) return;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (build() || tries > 20) clearInterval(t);
    }, 300);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();

/* Article journal layout: wrap the body in a grid and build a sticky
   "In this article" table of contents from the H2 headings, with scroll-spy. */
(function () {
  function buildTOC() {
    if (!document.body.classList.contains('template-article')) return;
    var content = document.querySelector('.article-template__content');
    if (!content || content.closest('.cs-article-layout')) return;
    var heads = content.querySelectorAll('h2');
    var layout = document.createElement('div');
    layout.className = 'cs-article-layout';
    content.parentNode.insertBefore(layout, content);
    layout.appendChild(content);
    if (heads.length < 2) return;
    var aside = document.createElement('aside');
    aside.className = 'cs-toc';
    var html = '<p class="cs-toc__label">In this article</p><ul class="cs-toc__list">';
    heads.forEach(function (h, i) {
      var id = h.id || ('cs-sec-' + i);
      h.id = id;
      html += '<li><a href="#' + id + '" data-t="' + id + '">' + h.textContent.trim() + '</a></li>';
    });
    html += '</ul>';
    aside.innerHTML = html;
    layout.appendChild(aside);
    var links = aside.querySelectorAll('a');
    function spy() {
      var p = window.scrollY + 150, cur = null;
      heads.forEach(function (h) { if (h.getBoundingClientRect().top + window.scrollY <= p) cur = h.id; });
      links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-t') === cur); });
    }
    window.addEventListener('scroll', spy, { passive: true });
    spy();
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var t = document.getElementById(a.getAttribute('data-t'));
        if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
      });
    });
  }
  if (document.readyState !== 'loading') buildTOC();
  else document.addEventListener('DOMContentLoaded', buildTOC);
})();

/* Wholesale Order Form: match the app's UI to the site design system.
   The app's own stylesheet is served cross-origin, so these are overrides.
   Scoped to /apps/shop - nothing else on the site is touched. */
(function () {
  if (location.pathname.indexOf('/apps/shop') !== 0) return;

  function skin() {
    if (document.getElementById('cs-wof-skin')) return;
    var st = document.createElement('style');
    st.id = 'cs-wof-skin';
    st.textContent =
      '#wof_order_from_main_container,#wof_order_from_main_container *:not(i):not(svg){font-family:\'Mulish\',system-ui,sans-serif;}' +
      '[id*="__notification-banner"]{display:none !important;}' +
      '#wof_tab_container .wof-tabs,#wof_tab_container .wof-tabs span{font-family:\'Newsreader\',Georgia,serif !important;font-weight:500 !important;font-size:40px !important;line-height:1.1 !important;color:#192846 !important;letter-spacing:0 !important;}' +
      '@media (max-width:749px){#wof_tab_container .wof-tabs,#wof_tab_container .wof-tabs span{font-size:30px !important;}}' +
      '.custom-wholesale-nav a.button{font-size:12.5px !important;font-weight:600 !important;letter-spacing:.05em !important;border-radius:2px !important;}' +
      '#wof_filter_button_wrapper,#wof_sort_by_button_wrapper,#wof_cart_widget_wrapper{border:1px solid #E6DFD2 !important;border-radius:2px !important;background:#fff !important;}' +
      '#lbl_filter,#lbl_sort_by{font-size:13px !important;font-weight:600 !important;color:#192846 !important;letter-spacing:.04em !important;}' +
      '#wof_txt_search{font-family:\'Mulish\',sans-serif !important;font-size:14px !important;border:1px solid #E6DFD2 !important;border-right:0 !important;border-radius:2px 0 0 2px !important;color:#44464A !important;}' +
      '#wof_product_table,#wof_product_table *{box-shadow:none !important;outline:none !important;}' +
      '#wof_product_table td,#wof_product_table th{border-left:0 !important;border-right:0 !important;}' +
      '#wof_product_table th{font-size:11.5px !important;font-weight:600 !important;letter-spacing:.16em !important;text-transform:uppercase !important;color:#8A8576 !important;border-bottom:1px solid #E6DFD2 !important;padding-bottom:14px !important;}' +
      '#wof_product_table td{font-size:15px !important;color:#44464A !important;padding-top:18px !important;padding-bottom:18px !important;}' +
      '#wof_product_table .wof-product-title{color:#192846 !important;font-weight:600 !important;line-height:1.45 !important;}' +
      '#wof_product_table tbody tr.product-row{border-bottom:1px solid #EAE3D6 !important;}' +
      '#wof_product_table tbody tr.product-row:hover{background:#FFFAF8 !important;}' +
      '#wof_order_from_main_container .quantity-box-wrapper{border:1px solid #E6DFD2 !important;border-radius:2px !important;}' +
      'button.wof-add-to-cart-button{font-family:\'Mulish\',sans-serif !important;font-size:12.5px !important;font-weight:600 !important;letter-spacing:.05em !important;background-color:#192846 !important;color:#FFFAF8 !important;border:1px solid #192846 !important;border-radius:2px !important;padding:12px 22px !important;}' +
      'button.wof-add-to-cart-button:hover{background-color:#2C517A !important;border-color:#2C517A !important;}';
    document.head.appendChild(st);
  }

  if (document.readyState !== 'loading') skin();
  else document.addEventListener('DOMContentLoaded', skin);
})();

/* Header CTA: the theme hardcodes two buttons - "Become a Stockist" and
   "Clinic Login" - in sections/header.liquid, in 2 places each, with no
   {% if customer %} anywhere. So a partner who is already signed in still sees
   "Clinic Login" (which dumps them on the Orders page), still sees an invitation
   to become a stockist they already are, and has no way to sign out: the theme
   has no logout link on any page.

   Until those lines can be made conditional in header.liquid, this rewrites
   them client-side.

     signed out   Become a Stockist -> /pages/contact   (unchanged)
                  Clinic Login      -> /account/login   (was a hardcoded
                                       shopify.com URL; the relative route keeps
                                       the visitor on the store domain, so a
                                       theme preview session survives)

     signed in    Become a Stockist -> hidden           (they already are one)
                  Order Form        -> /pages/order-form

   Order history has not gone away - it moved to a quiet link on the order form
   page itself (last block in this file), so the header stays down to one action
   plus Log out.

   Shopify exposes the signed-in customer id as window.__st.cid on every page. */
(function () {
  var SIGNED_IN = !!(window.__st && window.__st.cid);

  function set(a, href, label) {
    a.setAttribute('href', href);
    if (label) a.textContent = ' ' + label + ' ';
    a.setAttribute('data-cs-header', 'done');
  }

  function apply() {
    var login = document.querySelectorAll('a.header-login-btn');
    if (!login.length) return false;

    for (var i = 0; i < login.length; i++) {
      if (login[i].getAttribute('data-cs-header') === 'done') continue;
      if (SIGNED_IN) set(login[i], '/pages/order-form', 'Order Form');
      else set(login[i], '/customer_authentication/login?return_to=%2Fpages%2Forder-form', null);
    }

    if (SIGNED_IN) {
      var stockist = document.querySelectorAll('a.header-stockist-btn');
      for (var j = 0; j < stockist.length; j++) {
        if (stockist[j].getAttribute('data-cs-header') === 'done') continue;
        stockist[j].style.display = 'none';
        stockist[j].setAttribute('aria-hidden', 'true');
        stockist[j].setAttribute('data-cs-header', 'done');
      }
    }
    return true;
  }

  if (!apply()) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (apply() || tries > 30) clearInterval(t);
    }, 100);
    document.addEventListener('DOMContentLoaded', apply);
  }
})();

/* Wholesale Order Form, part 2: the two dropdown menus.
   The Filters panel and the Sort by list were still the app's defaults -
   16px, half-black headings, a browser-blue radio, an underlined active item.
   Same palette and type scale as the rest of the page. */
(function () {
  if (location.pathname.indexOf('/apps/shop') !== 0) return;

  function menuSkin() {
    if (document.getElementById('cs-wof-menu')) return;
    var st = document.createElement('style');
    st.id = 'cs-wof-menu';
    st.textContent =
      /* Filters panel */
      '#lbl_filter_collection_header{font-size:11.5px !important;font-weight:600 !important;' +
      'letter-spacing:.16em !important;text-transform:uppercase !important;color:#8A8576 !important;' +
      'padding-bottom:12px !important;border-bottom:1px solid #E6DFD2 !important;margin-bottom:4px !important;}' +
      '#collections_wrapper{padding-left:0 !important;list-style:none !important;}' +
      '#collections_wrapper li.collection-filter{font-size:14.5px !important;line-height:1.5 !important;' +
      'color:#44464A !important;padding:9px 0 !important;text-decoration:none !important;' +
      'transition:color .18s ease,padding-left .18s ease;}' +
      '#collections_wrapper li.collection-filter:hover{color:#2C517A !important;padding-left:6px !important;}' +
      '#collections_wrapper li.active-collection-filter{color:#192846 !important;font-weight:600 !important;' +
      'text-decoration:none !important;}' +
      /* Sort by dropdown */
      '#sort-by-dropdown-content{border:1px solid #E6DFD2 !important;border-radius:2px !important;' +
      'box-shadow:0 14px 34px rgba(25,40,70,.10) !important;padding:4px 0 !important;}' +
      '#sort-by-dropdown-content label{font-size:14px !important;color:#44464A !important;cursor:pointer;}' +
      '#sort-by-dropdown-content .sort-by-option{padding:5px 14px !important;border-color:#EAE3D6 !important;' +
      'transition:background .16s ease;}' +
      '#sort-by-dropdown-content .sort-by-option:hover{background:#FFFAF8 !important;}' +
      '#sort-by-dropdown-content input[type="radio"]{accent-color:#192846;}';
    document.head.appendChild(st);
  }

  if (document.readyState !== 'loading') menuSkin();
  else document.addEventListener('DOMContentLoaded', menuSkin);
})();

/* Wholesale Order Form: require sign-in AND an approved partner tag.

     not signed in       -> /account/login
     signed in, no tag   -> /pages/request-a-wholesale-account
     signed in, tagged   -> allowed through

   Reading the tags: the WPD pricing app already writes the signed-in customer's
   tags into the page as window.shopifyCustomer, a comma-joined string. That
   block is wrapped in {% if customer.tags.size > 0 or customer == null %}, so a
   signed-in customer carrying no tags at all leaves the variable undefined -
   which is itself the "not approved" signal.

   window.CS_TAGS is checked first so that if layout/theme.liquid is ever given
   its own tag line, this picks it up without a further change here.

   Note: this is a client-side gate, the same class of protection the Wholesale
   Lock Manager app applies. It is not a server-side lock - the markup is still
   in the response. Real enforcement belongs in the order form app's own
   "require login" setting, or in repairing the Wholesale Lock Manager rule,
   which still matches on the old myshopify.com domain and so never fires. */
(function () {
  if (location.pathname.indexOf('/apps/shop') !== 0) return;

  function bounce(url) {
    document.documentElement.style.visibility = 'hidden';
    location.replace(url);
  }

  if (!(window.__st && window.__st.cid)) {
    bounce('/account/login');
    return;
  }

  var tags = null;
  if (typeof window.CS_TAGS !== 'undefined' && window.CS_TAGS !== null) {
    tags = window.CS_TAGS;
  } else if (typeof window.shopifyCustomer === 'string') {
    tags = window.shopifyCustomer.split(',');
  }

  if (tags === null) {
    bounce('/pages/request-a-wholesale-account');
    return;
  }

  for (var i = 0; i < tags.length; i++) {
    if (String(tags[i]).trim().toLowerCase() === 'wholesale partner') return;
  }

  bounce('/pages/request-a-wholesale-account');
})();

/* Wholesale Order Form: start every quantity box at 0 instead of 1.

   The WSH app ships each row's quantity input pre-filled with 1 and marked
   min="1", so a clinic that only wants three of the forty-two products still
   has to zero out the other thirty-nine by hand - and a mis-click on "Add to
   cart" silently orders one unit. The app's own Settings page exposes no
   default-quantity option, so this is done here.

   Tested on the live order form before shipping:
     - all 42 boxes accept 0; the app raises no validation error
     - "Add to cart" with 0 adds nothing and shows no error
     - typing a number then "Add to cart" behaves exactly as before

   Only boxes still holding the app's untouched default of 1 are zeroed, so a
   quantity the customer typed is never overwritten. Each input is stamped once
   via dataset.csZeroed. The MutationObserver covers rows the app redraws in
   place (search, pagination); switching range filter is a full page load, which
   re-runs this file from scratch.

   This is cosmetic and client-side. If a future app update renames
   .wof-quantity-text-box the selector stops matching and the form simply
   reverts to the app's default of 1 - nothing breaks. The proper fix is a
   default-quantity setting from the app's developer. It also does not change
   how the app pairs a product with its tester; that logic is the app's. */
(function () {
  if (location.pathname.indexOf('/apps/shop') !== 0) return;

  function zero() {
    var boxes = document.querySelectorAll('input[type="number"].wof-quantity-text-box');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.dataset.csZeroed) continue;
      box.dataset.csZeroed = '1';
      box.setAttribute('min', '0');
      if (box.value === '1') {
        box.value = '0';
        box.dispatchEvent(new Event('input', { bubbles: true }));
        box.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function start() {
    zero();
    if (window.MutationObserver) {
      new MutationObserver(zero).observe(document.body, { childList: true, subtree: true });
    }
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      zero();
      if (tries > 20) clearInterval(t);
    }, 300);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();

/* Header: give signed-in partners a way to log out.

   The theme has no logout link on any page, so the only way out was to open the
   hosted customer account portal on account.cosmeceuticalsolutions.com.au and
   find it there - a page that looks nothing like the site, which is confusing
   right after placing an order.

   This appends a grey "Log out" button beside the Order Form button, but only
   when someone is signed in. It reuses the theme's own .header__icon-name class
   so the size, padding and type match the navy buttons exactly - only the
   colours are overridden, so it reads as the secondary action. /account/logout is Shopify's own logout route -
   the same URL the customer_logout_link Liquid filter produces - and it returns
   the visitor to the storefront home page afterwards.

   Signed-out visitors see nothing new. Runs after the Header CTA block above,
   and retries because the header markup can arrive late. */
(function () {
  if (!(window.__st && window.__st.cid)) return;

  var LOGOUT_URL = '/account/logout';

  function styles() {
    if (document.getElementById('cs-logout-style')) return;
    var st = document.createElement('style');
    st.id = 'cs-logout-style';
    st.textContent =
      '.header__icon-name.cs-logout{background-color:#E5E7EB !important;' +
      'border:1px solid #E5E7EB !important;color:#44515F !important;' +
      'white-space:nowrap;}' +
      '.header__icon-name.cs-logout:hover{background-color:#D3D7DD !important;' +
      'border:1px solid #D3D7DD !important;color:#071D33 !important;}';
    document.head.appendChild(st);
  }

  function apply() {
    var bars = document.querySelectorAll('.header_cta_btn');
    if (!bars.length) return false;

    styles();

    for (var i = 0; i < bars.length; i++) {
      if (bars[i].querySelector('.cs-logout')) continue;
      var a = document.createElement('a');
      a.className = 'header__icon-name cs-logout';
      a.setAttribute('data-cs-header', 'done');
      a.href = LOGOUT_URL;
      a.textContent = 'Log out';
      bars[i].appendChild(a);
    }
    return true;
  }

  if (!apply()) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (apply() || tries > 30) clearInterval(t);
    }, 100);
    document.addEventListener('DOMContentLoaded', apply);
  }
})();

/* Order form: "View order history" link.

   Order history lives in Shopify's hosted customer account portal on
   account.cosmeceuticalsolutions.com.au. Nothing can change that - New Customer
   Accounts is not themeable on any plan - but nothing says it has to sit in the
   header either. Taking it out of the header leaves one obvious action there
   (Order Form) plus Log out, and puts the history link where a clinic actually
   thinks of it: on the order form itself, under the intro.

   Signed-out visitors and pages other than the order form see nothing. */
(function () {
  if (!(window.__st && window.__st.cid)) return;
  if (location.pathname.indexOf('/pages/order-form') !== 0) return;

  function styles() {
    if (document.getElementById('cs-history-style')) return;
    var st = document.createElement('style');
    st.id = 'cs-history-style';
    st.textContent =
      '.cs-history{display:inline-flex;align-items:center;gap:7px;margin-top:16px;' +
      'font-family:\'Mulish\',system-ui,sans-serif;font-size:13.5px;letter-spacing:.02em;' +
      'color:#6B6E76;text-decoration:underline;text-underline-offset:3px;' +
      'transition:color .18s ease;}' +
      '.cs-history:hover{color:#192846;}' +
      '.cs-history span{transition:transform .18s ease;}' +
      '.cs-history:hover span{transform:translateX(3px);}';
    document.head.appendChild(st);
  }

  function apply() {
    var hero = document.querySelector('.cs-of__hero .page-width');
    if (!hero) return false;
    if (hero.querySelector('.cs-history')) return true;

    styles();

    var a = document.createElement('a');
    a.className = 'cs-history';
    a.href = '/account';
    a.innerHTML = 'View order history <span aria-hidden="true">&rarr;</span>';

    var after = hero.querySelector('.cs-of__intro') || hero.querySelector('.cs-of__title');
    if (after && after.parentNode) after.parentNode.insertBefore(a, after.nextSibling);
    else hero.appendChild(a);
    return true;
  }

  if (!apply()) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (apply() || tries > 30) clearInterval(t);
    }, 100);
    document.addEventListener('DOMContentLoaded', apply);
  }
})();

/* Cart: send "Continue shopping" back to the order form.

   The cart page's Continue shopping link is hardcoded in
   sections/main-cart-items.liquid to routes.all_products_collection_url, so a
   clinic part-way through an order lands on the retail product grid instead of
   the form they were filling in, and has to find their own way back. The
   empty-cart button points at the collection list for the same reason.

   Only rewritten for signed-in customers - a logged-out visitor has no order
   form to return to, and the product grid is the right destination for them. */
(function () {
  if (!(window.__st && window.__st.cid)) return;
  if (location.pathname.indexOf('/cart') !== 0) return;

  var FORM_URL = '/pages/order-form';

  function apply() {
    var found = false;

    var back = document.querySelector('.page-header__inner a.button--with-underline');
    if (back) {
      back.setAttribute('href', FORM_URL);
      found = true;
    }

    var empty = document.querySelector('.cart__warnings a.button--primary');
    if (empty) {
      empty.setAttribute('href', FORM_URL);
      var label = empty.querySelector('span');
      if (label) label.textContent = 'Back to the order form';
      found = true;
    }

    return found;
  }

  if (!apply()) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (apply() || tries > 30) clearInterval(t);
    }, 100);
    document.addEventListener('DOMContentLoaded', apply);
  }
})();

/* Header: bring back the cart link, with a live count.

   assets/custom.css hides it outright (#cart-icon-bubble { display: none }),
   which is defensible for a brochure site but not for one people order from:
   after adding a few lines and coming back to the form there was nothing on
   screen saying anything was in the cart at all.

   The theme's own markup is fine - a "Cart" label and a (n) bubble - it was
   only ever hidden, so this unhides it rather than building a second one. The
   number is refreshed from /cart.js because Liquid stamped it when the page
   was cached, which on a static page can be minutes or hours out of date.

   Signed-in customers only; a logged-out visitor's pages are unchanged. */
(function () {
  if (!(window.__st && window.__st.cid)) return;

  function styles() {
    if (document.getElementById('cs-cart-style')) return;
    var st = document.createElement('style');
    st.id = 'cs-cart-style';
    st.textContent =
      '#cart-icon-bubble.cs-cart{display:inline-flex !important;align-items:center;' +
      'gap:5px;margin-left:18px;white-space:nowrap;}' +
      '#cart-icon-bubble.cs-cart .cart-count-bubble{display:inline;}' +
      '@media (max-width:989px){#cart-icon-bubble.cs-cart{margin-left:12px;}}';
    document.head.appendChild(st);
  }

  function paint(count) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return false;

    styles();
    icon.classList.add('cs-cart');
    icon.setAttribute('href', '/cart');
    icon.setAttribute('aria-label', 'Cart, ' + count + ' item' + (count === 1 ? '' : 's'));

    var bubble = icon.querySelector('.cart-count-bubble');
    if (bubble) {
      var live = bubble.querySelector('.cs-cart__n');
      if (!live) {
        bubble.innerHTML = '';
        live = document.createElement('span');
        live.className = 'cs-cart__n';
        bubble.appendChild(live);
      }
      live.textContent = '(' + count + ')';
    }
    return true;
  }

  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      if (!cart) return;
      var count = cart.item_count || 0;
      if (paint(count)) return;
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (paint(count) || tries > 30) clearInterval(t);
      }, 100);
    })
    .catch(function () {});
})();

/* Cart: the button says "Submit order", not "Check Out".

   Nothing is charged at this step - the clinic selects Bank Deposit and the
   invoice follows - so "Check Out" set the wrong expectation for a wholesale
   order, and Finance asked for wording that matches what actually happens.

   Two buttons carry the class: the WSH app injects its own and hides the
   theme's, so both are relabelled and the wording survives removing the app.
   The app redraws the cart after a quantity change, hence the observer; the
   relabel only writes when the text differs, so it settles immediately. */
(function () {
  if (location.pathname.indexOf('/cart') !== 0) return;

  var LABEL = 'Submit order';

  function relabel() {
    var btns = document.querySelectorAll('.cart__checkout-button');
    for (var i = 0; i < btns.length; i++) {
      var target = btns[i].querySelector('span') || btns[i];
      if (target.textContent.trim() !== LABEL) target.textContent = LABEL;
    }
  }

  function start() {
    relabel();
    if (window.MutationObserver) {
      new MutationObserver(relabel).observe(document.body, { childList: true, subtree: true });
    }
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      relabel();
      if (tries > 20) clearInterval(t);
    }, 300);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();

/* Cart: the WSH app injects its own #wof_checkout_btn and hides the theme's
   real checkout button with the rule "#wof_checkout_btn + button {display:none}".
   The app button carries no click handler, so pressing "Submit order" does
   nothing and the order can never be placed - Finance hit this on 11 Sep.
   Removing the app button drops the sibling selector, so the theme button
   (name="checkout", inside form action="/cart") becomes visible again and
   submits to checkout natively. The observer is here because the app redraws
   the cart after a quantity change. Safe to keep after the app is removed. */
(function () {
  if (location.pathname.indexOf('/cart') !== 0) return;

  function strip() {
    var dead = document.getElementById('wof_checkout_btn');
    if (dead && dead.parentNode) dead.parentNode.removeChild(dead);
  }

  function start() {
    strip();
    if (window.MutationObserver) {
      new MutationObserver(strip).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/* Header: one Clinic Login button for signed-out visitors.
   Finance found the way in confusing: Clinic Login went straight to
   Shopify's login, where anyone can create an account, and Become a
   Stockist sat beside it. Signed-out visitors now see Clinic Login only,
   and it opens a panel with three routes:
     Log in            - approved stockists (keeps the login link set above)
     Request access    - existing stockists without an online account
     Become a stockist - everyone else
   Signed-in customers are left alone: the block above already turns the
   button into Order Form and adds Log out. Shopify cannot stop someone
   creating an account from the login screen, but an account shows no
   prices until the Wholesale Partner tag is added. */
(function () {
  if (window.__st && window.__st.cid) return;

  var REQUEST_URL = '/pages/request-a-wholesale-account';
  var STOCKIST_URL = '/pages/contact';

  var CSS = [
    '.cs-lp-host{position:relative}',
    '.cs-lp{box-sizing:border-box;width:360px;max-width:calc(100vw - 32px);background:#fff;border:1px solid #E3D5CC;box-shadow:0 18px 40px rgba(25,40,70,.14);padding:24px 24px 18px;text-align:left;font-family:Mulish,system-ui,sans-serif;z-index:60}',
    '.cs-lp,.cs-lp *{text-transform:none;letter-spacing:normal}',
    '.cs-lp[hidden]{display:none}',
    '.header__account .cs-lp{position:absolute;top:calc(100% + 14px);right:0}',
    '.header__account .cs-lp:before{content:"";position:absolute;top:-7px;right:44px;width:12px;height:12px;background:#fff;border-left:1px solid #E3D5CC;border-top:1px solid #E3D5CC;transform:rotate(45deg)}',
    '.cs-lp-host:not(.header__account) .cs-lp{position:static;width:100%;margin-top:12px}',
    '.cs-lp__eyebrow{font-size:11px;letter-spacing:.14em!important;text-transform:uppercase!important;color:#8A7A70;margin:0 0 6px}',
    '.cs-lp__title{font-family:Newsreader,Georgia,serif;font-size:24px;line-height:1.2;color:#192846;margin:0 0 16px;font-weight:500}',
    '.cs-lp__opt{display:block;text-decoration:none;padding:13px 16px;margin:0 0 10px;border:1px solid #1F4268}',
    '.cs-lp__opt strong{display:flex;justify-content:space-between;align-items:center;font-size:15px;font-weight:600}',
    '.cs-lp__opt span{display:block;font-size:13px;line-height:1.45;margin-top:3px}',
    '.cs-lp__opt em{font-style:normal;font-size:16px}',
    '.cs-lp__opt--primary{background:#1F4268;color:#fff}',
    '.cs-lp__opt--primary span{color:rgba(255,255,255,.8)}',
    '.cs-lp__opt--secondary{background:#FFFAF8;color:#192846}',
    '.cs-lp__opt--secondary span{color:#5A5F6B}',
    '.cs-lp__opt:hover{text-decoration:none;opacity:.92}',
    '.cs-lp__foot{border-top:1px solid #EFE4DE;margin:8px 0 0;padding-top:14px;font-size:13px;color:#5A5F6B}',
    '.cs-lp__foot a{color:#192846;font-weight:600;text-decoration:underline;text-underline-offset:3px}',
    '.header__account .cs-lp-toggle{display:inline-flex!important;align-items:center;gap:9px}',
    '.header__account .cs-lp-toggle:after{content:"";display:inline-block!important;width:6px;height:6px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:translateY(-2px) rotate(45deg);transition:transform .2s}',
    '.header__account .cs-lp-toggle[aria-expanded="true"]:after{transform:translateY(1px) rotate(-135deg)}'
  ].join('');

  var PANEL =
    '<p class="cs-lp__eyebrow">For approved stockists</p>' +
    '<p class="cs-lp__title">Wholesale ordering</p>' +
    '<a class="cs-lp__opt cs-lp__opt--primary cs-lp__login" href="#">' +
      '<strong>Log in <em aria-hidden="true">&rarr;</em></strong>' +
      '<span>I already have an online account</span></a>' +
    '<a class="cs-lp__opt cs-lp__opt--secondary" href="' + REQUEST_URL + '">' +
      '<strong>Request access <em aria-hidden="true">&rarr;</em></strong>' +
      '<span>I&rsquo;m an existing stockist without an online account.</span></a>' +
    '<p class="cs-lp__foot">Not a stockist yet? <a href="' + STOCKIST_URL + '">Become a stockist</a></p>';

  var panels = [];

  function closeAll() {
    for (var i = 0; i < panels.length; i++) {
      panels[i].panel.hidden = true;
      panels[i].btn.setAttribute('aria-expanded', 'false');
    }
  }

  function build(btn, n) {
    var host = btn.parentElement;
    if (!host || host.getAttribute('data-cs-panel') === 'done') return;
    host.setAttribute('data-cs-panel', 'done');
    host.classList.add('cs-lp-host');

    var stockist = host.querySelector('a.header-stockist-btn');
    if (stockist) stockist.style.display = 'none';
    if (btn.textContent.trim() === 'Login') btn.textContent = 'Clinic Login';

    var panel = document.createElement('div');
    panel.className = 'cs-lp';
    panel.id = 'cs-lp-' + n;
    panel.hidden = true;
    panel.innerHTML = PANEL;
    host.appendChild(panel);

    btn.classList.add('cs-lp-toggle');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', panel.id);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var opening = panel.hidden;
      closeAll();
      if (!opening) return;
      /* Read the login link now, not at build time, so it always matches
         what the block above set it to. */
      panel.querySelector('.cs-lp__login').setAttribute('href', btn.getAttribute('href'));
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    });

    panels.push({ btn: btn, panel: panel });
  }

  function start() {
    if (!document.getElementById('cs-lp-css')) {
      var s = document.createElement('style');
      s.id = 'cs-lp-css';
      s.textContent = CSS;
      document.head.appendChild(s);
    }
    var btns = document.querySelectorAll('a.header-login-btn');
    for (var i = 0; i < btns.length; i++) build(btns[i], i);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.cs-lp-host')) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
